module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/battle-disabled-normal-50.60f03366.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/battle-disabled-normal-50.png
// module id = 3414
// module chunks = 11